import React from 'react'


export default function CardProduct({ image, title, price }) {
  return (
    <div className="card">
      <div className="card-img-container">
        <img src={image} alt={title} className="card-img" />
      </div>
      <div className="card-body">
        <h3 className="card-title">{title}</h3>
        <p className="card-price">{price}</p>
      </div>
    </div>
  );
};
